import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Spin } from 'antd';
import axios from 'axios';

import RefillsList from './RefillsList';
import { SET_REFILLS } from '../../ActionTypes/ActionTypes';

class InactiveRefills extends Component {
    state = {
        loading: false,
    }

    componentDidMount = () => {
        const { setRefills } = this.props;

        this.setState({ loading: true });
        axios({
            method: 'get',
            url: '/carefills/carefills_by_status.json?status=Inactive',
            headers: { Authorization: sessionStorage.getItem('jwtToken') },
        })
            .then((response) => {
                this.forceUpdate();
                setRefills(response.data.carefills);
                this.setState({
                    loading: false,
                });
            });
    }

    render() {
        const { loading } = this.state;
        return (
            <div>
                {
                    loading
                        ? <Spin />
                        : <RefillsList />
                }

            </div>
        );
    }
}

const mapStateToProps = state => ({
    refillsList: state.RefillState.refillsList,
});

const mapDispatchToProps = dispatch => ({
    setRefills: data => dispatch({ type: SET_REFILLS, payload: { data } }),
});

export default connect(mapStateToProps, mapDispatchToProps)(InactiveRefills);



// WEBPACK FOOTER //
// ./src/component/RefillManagementSystem/InactiveRefills.js